import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-svg-co-browse',
  templateUrl: './co-browse.component.html',
  styleUrls: ['./co-browse.component.scss']
})
export class CoBrowseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
